import axios from '../library/axiosConfig'
import qs from 'qs'

export default {
  /**
   * @param data  {param,config}
   * @returns {AxiosPromise<any>}
   */
  cashierDesk(data) {
    return axios.post('/pay/v1/cashierDesk', data.param, Object.assign({baseURL: axios.defaults.saleUrl}, data.config))
  },
  /**
   * 支付接口
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getPaySignatureByApi2(data){
    return axios.post('/pay/v1/getPaySignature', data.param, Object.assign({baseURL: axios.defaults.saleUrl}, data.config))
  },
  /**
   * 解锁订单
   * @param data
   * @returns {AxiosPromise<any>}
   */
  unLockBill(data){
    return axios.post('/pay/v1/unLockBill', data.param, Object.assign({baseURL: axios.defaults.saleUrl}, data.config))
  },
  /**
   * 获取账单详情
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getBillDetail(data) {
    return axios.post(`/renterAccount/v1/queryBillDetail?${qs.stringify(data.param)}`, data.param, Object.assign({baseURL: axios.defaults.saleUrl}, data.config))
  },
  /**
   * 账单列表页面，顶部租约信息
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getOrderInfo(data = {param: {}, config: {}}) {
    return axios.post(`/renterAccount/v1/queryOrder?${qs.stringify(data.param)}`, data.param, Object.assign({baseURL: axios.defaults.saleUrl}, data.config))
  },
  /**
   * 账单列表页面，获取可查看账单的租约列表
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getOrderList(data = {param: {}, config: {}}) {
    return axios.post(`/renterAccount/v1/queryOrderList`, data.param, Object.assign({baseURL: axios.defaults.saleUrl, brandCustom: true}, data.config))
  },
  /**
   * 获取已支付列表
   * @param datas
   * @returns {AxiosPromise<any>}
   */
  getPayDoneBillList(data = {param: {}, config: {}}) {
    return axios.post(`/renterAccount/v1/queryPayDoneBillList?${qs.stringify(data.param)}`, data.param, Object.assign({baseURL: axios.defaults.saleUrl}, data.config))
  },
  /**
   * 获取未支付列表
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getUnPayBillList(data = {param: {}, config: {}}) {
    return axios.post(`/renterAccount/v1/queryUnPayBillList?${qs.stringify(data.param)}`, data.param, Object.assign({baseURL: axios.defaults.saleUrl}, data.config))
  },
  /**
   * 选择账单，获取是否支持卡券
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getBillCanUseCouponList(data) {
    return axios.post(`/coupon/v1/queryBillListCanUseCouponList?${qs.stringify(data, {allowDots: true})}`, {}, {baseURL: axios.defaults.saleUrl} )
  },
  /**
   * 获取信用租收银台
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getCreditCashier(data) {
    return axios.post(`/pay/v1/getModePayment?${qs.stringify(data, {allowDots: true})}`, {}, {baseURL: axios.defaults.saleUrl} )
  },
  // 同步账单支付状态
  syncBillStatus(data) {
    return axios.post('/pay/v1/syncBillStatus', data.param, Object.assign({baseURL: axios.defaults.saleUrl, brandCustom: true}, data.config))
  },
  // 支付成功页，是否显示评价入口
  getEvalButton(data) {
    return axios.post(`/order/v1/getEvalButton?${qs.stringify(data, {allowDots: true})}`, {}, Object.assign({baseURL: axios.defaults.saleUrl, brandCustom: true}, data.config))
  },
  scanSkipJudge(data){
    return axios.post(`/scan/v1/scanSkipJudge?${qs.stringify(data.param)}`, data.param, Object.assign({baseURL: axios.defaults.saleUrl}, data.config))
  },
  //  租约列表
  getLeaseList(data) {
    return axios.post(`/order/v1/listRenterOrder`, data, {baseURL: axios.defaults.saleUrl, brandCustom: true})
  },
  // 租约详情
  getLeaseDetail(data) {
    return axios.post(`/order/v1/queryOrderDetail`, data, {baseURL: axios.defaults.saleUrl, brandCustom: true})
  },
  // 二房东租约详情签署合同获取QBB链接
  getQbbContractSignInfo(data) {
    return axios.post(`/order/v1/getQbbContractSignInfo`, data, {baseURL: axios.defaults.saleUrl, brandCustom: true})
  },
  //  确认租约（纸质合同直接确认）
  confirmLease(data){
    return axios.post(`/order/v1/confirmSignedOrder`, data, {baseURL: axios.defaults.saleUrl, brandCustom: true})
  },
  //  预览电子合同
  getContractInfo(data){
    return axios.post(`/order/v1/previewContract`, data, {baseURL: axios.defaults.saleUrl, brandCustom: true})
  },
  /**
   * 查看电子合同
   * @param data
   * @returns {*}
   */
  viewerContract(data) {
    return axios.post('/order/v1/findContractUrl', data, {baseURL: axios.defaults.saleUrl, brandCustom: true})
  },
  /**
   * 报修列表
   * @param data
   * @returns {*}
   */
  queryRepairList(data) {
    return axios.post(`/support/queryRepairList`, data.param, {baseURL: axios.defaults.renterEmbed, json: true})
  },
  /**
   * 报修列表
   * @param data
   * @returns {*}
   */
  getExistRentalSource(data) {
    return axios.post(`/support/existRentalSource`, data.param, {baseURL: axios.defaults.renterEmbed, json: true})
  },
  /**
   * 添加报修页面初始化查询
   * @param data
   * @returns {*}
   */
  queryRepairInitInfo(data) {
    return axios.post(`/support/queryRepairInitInfo`, data.param, {baseURL: axios.defaults.renterEmbed, json: true})
  },
  /**
   * 添加报修
   * @param data
   * @returns {*}
   */
  saveRepair(data) {
    return axios.post(`/support/saveRepair`, data.param, {baseURL: axios.defaults.renterEmbed, json: true})
  },
  /**
   * 图片上传
   * @param data
   * @returns {*}
   */
  fileUpload(data) {
    return axios.post(`/file/fileUpload`, data.param, {baseURL: axios.defaults.renterEmbed, json: true})
  },
  //智能家居
  checkElectricMeter(data) {
    return axios.post('/smrt/lifePublicNo/v1/queryHwRooms', data, {baseURL: axios.defaults.saleUrl,json:true})
  },
  ammeterStates(data) {
    return axios.post('/smrt/lifePublicNo/v1/queryElemInfo', data, {baseURL: axios.defaults.saleUrl, json: true})
  },
  //查询门锁信息
  roomLockInfo(data) {
    return axios.get('/smrt/lifePublicNo/v1/roomLockInfo', {params: data, baseURL: axios.defaults.saleUrl})
  },
  // 发送门锁密码
  updateLockPwd(data) {
    return axios.post('/smrt/lifePublicNo/v1/updateLockPwd', data, {baseURL: axios.defaults.saleUrl})
  },
  // 获取用户芝麻信用信息
  zmxyGrantAuthority (data) {
    return axios.get(`/zmxy/zmxyGrantAuthority`, Object.assign({baseURL: axios.defaults.renterEmbed}, data))
  },
  //
  queryOrderBillTypes (data) {
    return axios.post(`/bill/queryOrderBillTypes`, data, {baseURL: axios.defaults.renterEmbed})
  },
  //
  getLifePublicNoFetchPowers (data) {
    return axios.post(`/smrt/lifePublicNo/v1/fetchPowers`, data, {baseURL: axios.defaults.saleUrl, json: true})
  },
  /**
   * 账单列表 详情 创建他人代付订单
   * @param data
   * @returns {AxiosPromise<any>}
   */
  createOtherPayBill(data) {
    return axios.post(`/ohterPay/v1/createOtherPayBill`, data, Object.assign({baseURL: axios.defaults.saleUrl, json: true}))
  },
  /**
   * 获取他人代付订单基础信息
   * @param data
   * @returns {AxiosPromise<any>}
   */
  getOtherPayBillBaseInfo(data) {
    return axios.post(`/ohterPayNoAuth/v1/getOtherPayBillBaseInfo?otherPayId=${data.param}`, {}, {baseURL: axios.defaults.saleUrl});
  },
  //  获取他人代付账单详情
  getOtherPayBillDetail(data) {
    return axios.post(`/ohterPayNoAuth/v1/getOhterPayBillDetailInfo?${qs.stringify(data)}`, {}, {baseURL: axios.defaults.saleUrl});
  },
  //  创建他人代付url
  createRealPayBill(data) {
    return axios.post(`/ohterPayNoAuth/v1/createRealPayBill?${qs.stringify(data)}`, {}, {baseURL: axios.defaults.saleUrl});
  }
}



// WEBPACK FOOTER //
// ./src/api/renterEmbed.js